import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Success() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to home page after 3 seconds
    const timer = setTimeout(() => {
      navigate('/');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="success-page">
      <h2>Payment Successful!</h2>
      <p>Thank you for your payment. You can now participate in the game.</p>
      <p>Redirecting to game page...</p>
    </div>
  );
}

export default Success; 